//let years2015_11_05 = ['2015', '2011', '2005']

//let allYears = ['2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010', '2009', '2008', '2007', '2006', '2005', '2004']
let last10years = ['2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010', '2009', '2008']
//let recentYears = ['2017', '2016', '2015', '2014', '2013', '2012', '2011']

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
let years = ['2018', '2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010', '2009', '2008', '2007', '2006', '2005', '2004']

let months = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']

let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
let monthsForYear = function(year) {
  if (year === '2018') return months.slice(0,2)
  return months
}


//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
/*let geoCountry = {
  "Alemania":"DE",
  "Australia":"AU",
  "Brasil":"BR",
  "Corea":"KR",
  "España":"ES",
  "Estados Unidos":"US",
  "France":"FR",
  "Francia":"FR",
  "Holanda":"NL",
  "Irlanda":"IE",
  "Italia":"IT",
  "Portugal":"PT",
  "Reino Unido":"GB",
  "Spain":"ES",
  "":"ES"
}*/

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
//let months3 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
let tableSpec = {
  home: {
    title:"Home",
    charts:[],
  },
  age: {
    paging:false,
    img:'palaisDeReiBridge.jpg',
    tag:'by-age',
    title:'By Age',
    longTitle:'Age of Pilgrim',
    field:'age',
    charts:[
      {type:'lines', years:last10years, height:400, usePercent:true, curve:false,
      titles:['<30', '30 to 60', '>60'],
      width:"600px"}
    ],
  },

  camino: {
    paging:false,
    img:'fisterra.jpg',
    tag:'by-camino',
    title:'By Camino',
    longTitle:'Camino Traveled',
    field:'caminos',
    charts:[
      {type:'lines', years:last10years, height:400, usePercent:false, curve:false,
      titles:['Frances', 'Portugues', 'Norte', 'Primitivo', 'Ingles', 'La Plata', 'Finisterre', 'Other', 'Invierno', ]}
    ],
  },

  cityStarted: {
    paging:true,
    img:'km790sign.jpg',
    tag:'by-starting-city',
    title:'Started At',
    longTitle:'City Pilgrim Started In',
    field:'startingCities',
    charts:[
      {type:'lines', years:last10years, maxLines:14, height:600, usePercent:true, curve:false,
      titles:['Sarria', 'S. Jean', 'Oporto', 'Tui', 'León', 'Ferrol', 'Cebreiro', 'Oviedo', 'Ponferrada', 'Valença', 'Roncesvalles', 'Astorga', 'Irún']}
    ],
  },

  completions: {
    paging:false,
    img:'sillouette1.jpg',
    tag:'by-month',
    title:'By Month',
    longTitle:'Month Pilgrim Completed Camino',
    field:'completions',
    charts:[
      {type:'lines', years:last10years, height:400, ytitle:'# of pilgrims', usePercent:false},
      {type:'lines', years:last10years, height:400, ytitle:'% of pilgrims', usePercent:true, suffix:"$"},
    ],
  },

  countryFrom: {
    paging:true,
    img:'trail1.jpg',
    tag:'by-country',
    title:'By Nationality',
    longTitle:'Country Pilgrim Is From',
    field:'byCountry',
    charts:[
      {type:'lines', years:last10years, height:400, maxLines:13, usePercent:true, skipRow1:true,
      titles:['Spain', 'Italy', 'Germany', 'USA', 'Portugal', 'France', 'Ireland', 'UK', 'Brazil', 'Korea', 'Poland', 'Australia', 'Canada', 'Holland']}
    ],
  },

  countryStarted: {
    paging:true,
    img:'meseta1.jpg',
    tag:'by-starting-region',
    title:'Region Started',
    longTitle:'Country Pilgrim Started In',
    field:'startingRegions',
    charts:[
      {type:'lines', years:last10years, maxLines:14, height:400, usePercent:true,
      titles:['Lugo', 'Portugal', 'France', 'León', 'Pontevedra', 'Asturias', 'A Coruña', 'Navarra', 'Gipuzkoa', 'Ourense', 'Burgos', 'Sevilla', 'Cantabria']}
    ],
  },

  gender: {
    paging:false,
    img:'shadows1.jpg',
    tag:'by-gender',
    title:'By Gender',
    longTitle:'Gender of Pilgrim',
    field:'gender',
    charts:[
      {type:'lines', years:last10years, height:350, usePercent:true,
      titles:['Men', 'Women'], width:"400px", curve:false, minValue:40}
    ],
  },

  profession: {
    paging:true,
    img:'cowboyBar.jpg',
    tag:'by-profession',
    title:'By Profession',
    longTitle:'Profession of Pilgrim',
    field:'professions',
    charts:[
      {type:'lines', years:last10years, height:400, maxLines:14, usePercent:true,
      titles:['Employees', 'Students', 'Retirees', 'Professional', 'Technical', 'Teachers', 'Civil Servants', 'Housewives', 'Managers', 'Unemployed', 'Workers', 'Artists', 'Priests']}
    ],
  },

  reason: {
    paging:false,
    img:'cathedrals1.jpg',
    tag:'by-reason',
    title:'By Motivation',
    longTitle:'Reason for Pilgrimage',
    field:'motivation',
    charts:[
      {type:'lines', years:last10years, height:400, usePercent:true, width:"400px", curve:false,
      titles:['Cultural', 'Religious', 'Other']}
    ],
  },

  spanishCityFrom: {
    paging:true,
    img:'manjarin.jpg',
    tag:'spanish-by-region',
    title:'By Spanish Region',
    longTitle:'City (for Spanish Pilgrims)',
    field:'spanishFrom',
    charts:[
      {type:'lines', years:last10years, height:450, maxLines:14, usePercent:true,
      titles:['Andalucía', 'Madrid', 'Comunidad Valenciana', 'Cataluña', 'Galicia', 'Castilla la Mancha', 'Castilla León', 'Pais Vasco', 'Extremadura', 'Canarias', 'Murcia', 'Aragón', 'Asturias', 'Baleares']}
    ],
  },

  travel: {
    paging:false,
    img:'longTrail1.jpg',
    tag:'by-transport',
    title:'Method of Travel',
    longTitle:'Method of Travel',
    field:'transport',
    charts:[
      {type:'lines', years:last10years, height:400, curve:false, usePercent:true,
      titles:['Walking', 'Bicycle', 'Wheelchair', 'Horse', 'Vela']}
    ],
  },
}

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
/*let geoRegion = {
  "A Coruña":"ES-C",
  "Asturias":"ES-O",
  "Burgos":"ES-BU",
  "Gipuzkoa":"ES-SS",
  "León":"ES-LE",
  "Lugo":"ES-LU",
  "Navarra":"ES-NA",
  "Ourense":"ES-OR",
  "Pontevedra":"ES-PO",
  "Sevilla":"ES-SE",
  "France":"ES-TF",
  "Portugal":"ES-TF",
  "":"ES-TF"
}*/

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
let translateProfession = {
  "Estudiantes": "Students",
  "Empleados": "Employees",
  "Jubilados": "Retirees",
  "Liberales": "Professional",
  "Tecnicos": "Technical",
  "Profesores": "Teachers",
  "Funcionarios": "Civil Servants",
  "Amas de Casa": "Housewives",
  "Parados": "Unemployed",
  "Directivos": "Managers",
  "Obreros": "Workers",
  "Artistas": "Artists",
  "Sacerdotes": "Priests",
  "Religiosas": "Nuns",
  "Agricultores": "Farmers",
  "Marinos": "Sailers/Marines",
  "Deportistas": "Athletes",
  "Oikoten": `Other`
}

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
let translateTransport = {
  "Pie": "Walking",
  "Bicicleta": "Bicycle",
  "Caballo": "Horse",
  "Silla de ruedas": "Wheelchair",
}

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
let translateReason = {
  "All": "All",
  "Religioso y otros": "Cultural",
  "Religioso": "Religious",
  "No religioso": "Other",
}

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
let translateGender = {
  "All": "All",
  "Hombre": "Men",
  "Mujer": "Women",
}

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
let translateCamino = {
  "All": "All",
  "Frances": "Frances",
  "Frances-Camino de": "Frances",
  "Portugues": "Portugues",
  "Portugues-Camino": "Portugues",
  "Costa Camino Portugues": "Portugues",
  "Portugues Costa Camino": "Portugues",
  "Norte": "Norte",
  "Norte-Camino de": "Norte",
  "Primitivo": "Primitivo",
  "Primitivo-Camino": "Primitivo",
  "Finisterre": "Finisterre",
  "Muxia-Finisterre": "Finisterre",
  "Ingles": "Ingles",
  "Ingles-Camino": "Ingles",
  "La Plata": "La Plata",
  "Via de la Plata": "La Plata",
  "Other": "Other",
  "Otros caminos": "Other",
  "Invierno": "Invierno",
  "Camino de Invierno": "Invierno",
  "Invierno de Camino": "Invierno",
}

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
let countrySpanishToEnglish = {
  "Alemania":"Germany",
  "Afganistán":"Afghanistan",
  "Andorra":"Andorra",
  "Angola":"Angola",
  "Antigua y Barbuda":"Antigua & Barbuda",
  "Arabia Saudita":"Saudi Arabia",
  "Armenia":"Armenia",
  "Argelia":"Algeria",
  "Argentina":"Argentina",
  "Austria":"Austria",
  "Australia":"Australia",
  "Azerbaiyán":"Azerbaijan",
  "Belgica":"Belgium",
  "Bielorrusia":"Belarus",
  "Bolivia":"Bolivia",
  "Brasil":"Brazil",
  "Cabo Verde":"Cape Verde",
  "Camerún":"Cameroon",
  "Canadá":"Canada",
  "Chile":"Chile",
  "China":"China",
  "Chipre":"Cyprus",
  "Colombia":"Colombia",
  "Comores":"Comoros",
  "Corea":"Korea",
  "Costa de Marfil":"Ivory Coast",
  "Costa Rica":"Costa Rica",
  "Croacia":"Croatia",
  "Cuba":"Cuba",
  "Dinamarca":"Denmark",
  "Dominica":"Dominican Republic",
  "Ecuador":"Ecuador",
  "Egipto":"Egypt",
  "El Salvador":"El Salvador",
  "Emiratos Arabes Unidos":"U Arab Emirates",
  "Espana":"Spain",
  "España":"Spain",
  "Eslovaquia":"Slovakia",
  "Eslovenia": "Slovenia",
  "Estados Unidos":"USA",
  "Etiopia":"Ethiopia",
  "Filipinas":"Philippines",
  "Finlandia":"Finland",
  "Francia":"France",
  "Gabón":"Gabon",
  "Grecia":"Greece",
  "Groenlandia":"Greenland",
  "Guatemala":"Guatemala",
  "Haití":"Haiti",
  "Holanda":"Holland",
  "Holandesas":"Netherlands",
  "Hungría":"Hungary",
  "India":"India",
  "Indonesia":"Indonesia",
  "Irán":"Iran",
  "Irlanda":"Ireland",
  "Islandia":"Iceland",
  "Islas Feroe":"Faroe Islands",
  "Islas Malvinas":"Falkland Islands",
  "Israel":"Israel",
  "Italia":"Italy",
  "Japón":"Japan",
  "Jordania":"Jordan",
  "Kazajistán":"Kazakhstan",
  "Kirguistán":"Kyrgyzstan",
  "Letonia":"Latvia",
  "Líbano":"Lebanon",
  "Lituania":"Lithuania",
  "Luxemburgo":"Luxemburg",
  "Malasia":"Malaysia",
  "Martinica":"Martinique",
  "México":"Mexico",
  "Moldavia":"Moldavia",
  "Mónaco":"Monaco",
  "Nueva Caledonia":"New Caledonia",
  "Noruega":"Norway",
  "Nueva Zelanda":"New Zealand",
  "Omán":"Oman",
  "Pakistán":"Pakistan",
  "Panamá":"Panama",
  "Papúa - Nueva Guinea":"Papua New Guinea",
  "Paraguay":"Paraguay",
  "Perú":"Peru",
  "Polonia":"Poland",
  "Portugal":"Portugal",
  "Puerto Rico":"Puerto Rico",
  "Reino Unido":"UK",
  "Rep. Dominicana":"Dom. Rep.",
  "Rep. Centroafricana":"Central African Rep.",
  "República Checa":"Czech Rep.",
  "Roumania":"Romania",
  "Rumania":"Romania",
  "Rusia":"Russia",
  "Samoa Occidental":"Westrn Samoa",
  "Singapur":"Singapore",
  "Sierra Leona":"Sierra Leone",
  "Siria":"Syria",
  "Sudán":"Sudan",
  "Sudáfrica":"S. Africa",
  "Suecia":"Sweden",
  "Suiza":"Switzerland",
  "Swazilandia":"Swaziland",
  "Tailandia":"Thailand",
  "Taiwán":"Taiwan",
  "Timor Oriental":"East Timor",
  "Trinidad y Tobago":"Trinidad & Tobago",
  "Túnez":"Tunisia",
  "Turquía":"Turkey",
  "Ucrania":"Ukraine",
  "Urbekistán":"Uzbekistan",
  "Uruguay":"Uruguay",
  "Vanuatu":"Santo",
  "Venezuela":"Venezuela",
  "Bulgaria": "Bulgaria",
  "Estonia": "Estonia",
  "Malta": "Malta",
  "Nicaragua": "Nicaragua",
  "Honduras": "Honduras",
  "Marruecos": "Morocco",
  "Maldivas": "Maldives",
  "Namibia": "Namibia",
  "Serbia": "Serbia",
  "Albania": "Albania",
  "Sri Lanka": "Sri Lanka",
  "San Marino": "San Marino",
  "Madagascar": "Madagascar",
  "Bosnia": "Bosnia",
  "Tuvalu": "Tuvalu",
  "Kuwait": "Kuwait",
  "Bermudas": "Bermuda",
  "Gambia": "Gambia",
  "Nigeria": "Nigeria",
  "Zimbabwe": "Zimbabwe",
  "Kenya": "Kenya",
  "Macedonia": "Macedonia",
  "Eritrea": "Eritrea",
  "Botswana": "Botswana",
  "Palau": "Palau",
  "Guinea Ecuatorial": "Ecuatorial Guinea",
  "Antillas Holandesas": "Netherlands Antillas",
  "Jamaica": "Jamaica",
  "Nepal": "Nepal",
  "Granada": "Granada",
  "Ghana": "Ghana",
  "Burkina Faso": "Burkina Faso",
  "Lesotho": "Lesotho",
  "Mali": "Mali",
  "Yugoslavia": "Yugoslavia",
  "Barbados": "Barbados",
  "Surinam": "Surinam",
  "Irak": "Iraq",
  "Palestina": "Palestine",
  "Libia": "Libya",
  "Mauritania": "Mauritania",
  "Bangladesh": "Bangladesh",
  "Liechtensein": "Liechtenstein",
  "Mauricio": "Mauricio",
  "Camboya": "Cambodia",
  "Senegal": "Senegal",
  "Aruba": "Aruba",
  "Rwanda": "Rwanda",
  "Guyana": "Guyana",
  "Vietnam": "Vietnam",
  "Montenegro": "Montenegro",
  "Djibouti": "Djibouti",
  "Somalia": "Somalia",
  "Brunei": "Brunei",
  "Georgia": "Georgia",
  "Mozambique": "Mozambique",
  "Zambia": "Zambia",
  "Mongolia": "Mongolia",
  "Guam": "Guam",
  "Guinea": "Guinea",
  "Congo": "Congo",
  "Togo": "Togo",
  "Tanzania": "Tanzania",
  "Benin": "Benin",
  "Bahamas": "Bahamas",
  "Etiopía": "Etiopia",
  "Myanmar": "Myanmar",
  "Uganda": "Uganda",
  "I. Reunión": "Reunion Islands",
  "Laos": "Laos",
  "Fiji": "Fiji",
  "Santo Tomé y Príncipe": "Sao Tome & Principe",
  "Belice": "Belize",
  "Qatar": "Qatar",
  "Tayikistán": "Tayikistan",
  "Seychelles": "Seychelles",
  "Guinea - Bissau": "Guinea-Bissau",
  "Malawi": "Malawi",
  "Islas Caimán": "Cayman Islands",
  "Santa Lucía": "St. Lucia",
  "Chad": "Chad",
  "Bhután": "Bhutan",
  "Bahrein": "Bahrain",
  "Islas Vírgenes": "Virgin Islands",
  "Guayana Francesa": "French Guiana",
  "Liberia": "Liberia",
  "Turkmenistán": "Turkmenistan",
  "Herzegovina": "Herzegovina",
}

export {years, monthNames, monthsForYear, tableSpec, translateProfession, translateTransport, translateGender, translateReason, translateCamino, countrySpanishToEnglish}



// WEBPACK FOOTER //
// ./src/tables.js